import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useNotification } from "~/Hooks/useNotification";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { Navigation } from "../Navigation/Navigation";
import { AccreditationAndCertifications } from "./AccreditationAndCertifications/AccreditationAndCertifications";
import { TrainingAcademyBanner } from "./Banner/TrainingAcademyBanner";
import { fieldsReady } from "./constants";
import { NewsTab } from "./News/NewsTab";
import { OurClients } from "./OurClients/OurClients";
import { AddEditTrainingFacilities } from "./TrainingFacilities/AddEditTrainingFacilities";
import { useIntroduction } from "./TraningAcademy.hook";
import { Milestones } from "./MilestonesNew/Milestones";
import { VideoSection } from "./AccreditationAndCertifications/VideoSection";

export const TrainingAcademy = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [fieldData, setFieldData] = useState<any>();
  const [payloadData, setPayloadData] = useState<any>();

  async function fetchData() {
    try {
      const resolvedFields = await fieldsReady();
      console.log("fieldsReady", resolvedFields);
      setFieldData(resolvedFields);
    } catch (error) {
      console.error("Error fetching fields:", error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);
  const { data: introductionData, isLoading: isLoadingIntroduction, refetch: refetchIntroduction } = useIntroduction();
  const {
    data: TrainingAcademyDataById,
    isLoading: isLoadingTrainingAcademy,
    refetch: refetchData,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query?.get("id")) {
      return;
    }

    const activeTab = query.get("activeTab");
    const subActiveTab = query.get("subActiveTab");
    if (activeTab === "navigation") {
      navigate(
        `/dedicated/corporate/training-academy?activeTab=navigation&subActiveTab=${subActiveTab ?? "parentHeader"}`,
        {
          replace: true,
        }
      );
    } else if (activeTab === "news") {
      navigate(`/dedicated/corporate/training-academy?activeTab=news&subActiveTab=${subActiveTab ?? "latestNews"}`, {
        replace: true,
      });
    }  else if (activeTab === "ourClients") {
      navigate(`/dedicated/corporate/training-academy?activeTab=ourClients&subActiveTab=${subActiveTab ?? "ourClientsMainContent"}`, {
        replace: true,
      });
    }
    else if (activeTab === "milestones") {
      navigate(`/dedicated/corporate/training-academy?activeTab=milestones&subActiveTab=${subActiveTab ?? "milestoneOverview"}`, {
        replace: true,
      });
    }
    else {
      navigate(`/dedicated/corporate/training-academy?activeTab=${activeTab ?? "trainingAcademyBanner"}`, {
        replace: true,
      });
    }
    if (activeTab === "introduction") {
      refetchIntroduction();
    }
  }, [query.get("activeTab")]);

  useEffect(() => {
    if (query?.get("id")) {
      refetchData();
    }
  }, [query?.get("id")]);
  const IntroductionFormConfig: FormConfig = {
    initialValues: {
      field_introduction_text: TrainingAcademyDataById?.payload
        ? decodeHTML(TrainingAcademyDataById?.payload?.field_introduction_text)
        : decodeHTML(introductionData?.[0]?.field_introduction_text),
      field_introduction_text_ms: TrainingAcademyDataById?.payload
        ? decodeHTML(TrainingAcademyDataById?.payload?.field_introduction_text_ms)
        : decodeHTML(introductionData?.[0]?.field_introduction_text_ms),
      field_introduction_text_zhans: TrainingAcademyDataById?.payload
        ? decodeHTML(TrainingAcademyDataById?.payload?.field_introduction_text_zhans)
        : decodeHTML(introductionData?.[0]?.field_introduction_text_zhans),
      field_inrto_description: TrainingAcademyDataById?.payload
        ? decodeHTML(TrainingAcademyDataById?.payload?.field_inrto_description)
        : decodeHTML(introductionData?.[0]?.field_inrto_description),
      field_inrto_description_ms: TrainingAcademyDataById?.payload
        ? decodeHTML(TrainingAcademyDataById?.payload?.field_inrto_description_ms)
        : decodeHTML(introductionData?.[0]?.field_inrto_description_ms),
      field_inrto_description_zhans: TrainingAcademyDataById?.payload
        ? decodeHTML(TrainingAcademyDataById?.payload?.field_inrto_description_zhans)
        : decodeHTML(introductionData?.[0]?.field_inrto_description_zhans),
      intro_image: TrainingAcademyDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "intro_image.jpg",
              status: "done",
              url: TrainingAcademyDataById?.payload?.intro_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "intro_image.jpg",
              status: "done",
              url: introductionData?.[0]?.intro_image,
            },
          ]),
    },
    fields: fieldData?.introduction,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image", "intro_image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    let numberKeys: any = ["field_organisation_order_sequenc"];

    for (const key of numberKeys) {
      try {
        let field = data[key];
        if (field !== undefined && field !== null && field !== "") {
          data[key] = Number(field);
        }
      } catch (error) {
        console.error(`Error converting ${key} to number:`, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Malaysia Airport Academy",
      subModule: "introduction",
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Malaysia Airport Academy_Introduction",
      payload: {
        ...data,
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  const createAboutEramanSubItems = (label: string, key: string, formConfig: FormConfig) => ({
    label,
    key,
    children: (
      <DynamicForm
        config={formConfig}
        isLoading={isLoadingIntroduction || isLoadingTrainingAcademy}
        onSubmit={(data, buttonValue) =>
          onSubmit(
            data,
            `${corporateHost}/api/airports_acad_intro/${introductionData?.[0]?.id || TrainingAcademyDataById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING"
          )
        }
        defaultReviewNotes="Kindly review this Malaysia Airports Academy"
      />
    ),
  });

  const aboutEramanChildItems = [
    {
      label: "Banners",
      key: "trainingAcademyBanner",
      children: <TrainingAcademyBanner />,
    },
    createAboutEramanSubItems("Introduction", "introduction", IntroductionFormConfig),
    // createAboutEramanSubItems(
    //   "Timeline",
    //   "timeline",
    //   TimelineFormConfig
    // ),
    {
      label: "Accreditation & Certifications",
      key: "accreditationAndCertifications",
      children: <AccreditationAndCertifications />,
    },
    {
      label: "Video Section",
      key: "videoSection",
      children: <VideoSection />,
    },
    {
      label: "Milestones",
      key: "milestones",
      children: <Milestones />,
    },
    {
      label: "Our Clients",
      key: "ourClients",
      children: <OurClients />,
    },
    {
      label: "News",
      key: "news",
      children: <NewsTab />,
    },
    {
      label: "Training Facilities",
      key: "trainingFacilities",
      children: <AddEditTrainingFacilities />,
    },
    {
      label: "Navigation",
      key: "navigation",
      children: <Navigation />,
    },
    // {
    //   label: "Store Locations",
    //   key: 'storeLocations',
    //   children: <StoreLocations/>
    // },
    // createAboutEramanSubItems(
    //   "Homepage Popup",
    //   "homePagePopup",
    //   HomePagePopupFormConfig
    // ),
  ];

  const handleProductManagement = (activeTab: any, subActiveTab: any) => {
    if (activeTab === "trainingFacilities") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/corporate/training-academy/trainingFacilities/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Training Facility
        </Button>
      );
    } else if (activeTab === "trainingAcademyBanner") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/corporate/training-academy/banner/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Banner
        </Button>
      );
    } else if (activeTab === "milestones" && subActiveTab === "milestoneLinks") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/corporate/training-academy/milestone-link/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Links
        </Button>
      );
    } 
    else if (activeTab === "milestones" && subActiveTab === "milestoneOverview") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/corporate/training-academy/milestone-overview/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Overview
        </Button>
      );
    } 
    
    else if (activeTab === "news" && subActiveTab === "latestNewsList") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/corporate/training-academy/news/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Latest News
        </Button>
      );
    } else if (subActiveTab === "parentHeader") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/corporate/training-academy/navigation/parentHeader/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Parent Header
        </Button>
      );
    } else if (subActiveTab === "childHeader") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/corporate/training-academy/navigation/childHeader/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Child Header
        </Button>
      );
    } else if (subActiveTab === "grandChildHeader") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/corporate/training-academy/navigation/grandChildHeader/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Grandchild Header
        </Button>
      );
    }else if (activeTab === "ourClients" && subActiveTab === "localClients") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/corporate/training-academy/local-client/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Local Client
        </Button>
      );
    } else if (activeTab === "ourClients" && subActiveTab === "internationalClients") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/corporate/training-academy/international-client/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add International Client
        </Button>
      );
    } 
  };

  return (
    <ContentWrapper
      title={"Malaysia Airport Academy"}
      actionItems={handleProductManagement(query.get("activeTab"), query.get("subActiveTab"))}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={aboutEramanChildItems}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
